import axios from "axios";
import APIKit from "../APIKit";

function CommonService(api, payload) {

  return new Promise(async (resolve, reject) => {
    try {
      const token  = window.localStorage.getItem("auth_token");
      if (token) {
        payload.append("auth_token", token);
      }
    } catch (e) {

    }

    // Determine content type based on payload type
    let contentType = "multipart/form-data";
    if (payload instanceof URLSearchParams) {
      contentType = "application/x-www-form-urlencoded";
    }

    APIKit.post("/" + api, payload, {
      headers: {
        "content-type": contentType,
      }
    })
      .then(async (response) => {
        try {


          

          resolve(response.data);
        } catch (e) {
          console.error("err===========" + e);

          reject(e);
        }
      })
      .catch((err) => {
        console.error("err===========" + err);

        reject(err);
      });
  });
}


export const commonService = {
  CommonService,
};
